module.exports = __webpack_public_path__ + "img/condotech.2331c1ba.svg";